Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconHomeData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='20'%3e%3cpath d='M23.62 8.66L13.26.43a2.07 2.07 0 00-2.52 0L.38 8.66a1 1 0 001.24 1.57L3 9.14V18a2.08 2.08 0 002.14 2h13.72A2.08 2.08 0 0021 18V9.13l1.38 1.1a1 1 0 001.24-1.57zM14 18h-4v-5h4zm5 0a.22.22 0 01-.15.05H16V13a2 2 0 00-2-2h-4a2 2 0 00-2 2v5H5V7.55L12 2l7 5.55z' fill='currentColor'/%3e%3c/svg%3e",
  iconHomeWidth: 24,
  iconHomeHeight: 20
};